import { combineReducers, configureStore } from "@reduxjs/toolkit";
import appSlice from "./appSlice";
import user from "./user";
import game from "./game";
import codes from "./codes";

export const store = configureStore({
  reducer: combineReducers({
    app: appSlice,
    user,
    game,
    codes,
  }),
  devTools:
    process.env.NODE_ENV !== "production"
      ? {
          name: "HS Playground",
        }
      : false,
});

export const { getState, dispatch } = store;
